/* eslint-disable indent */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* global $ */
var BoundWidget = /** @class */ (function () {
    function BoundWidget(element, name, idForLabel, initialState) {
        var selector = ':input[name="' + name + '"]';
        this.input = element.find(selector).addBack(selector); // find, including element itself
        this.idForLabel = idForLabel;
        this.setState(initialState);
    }
    BoundWidget.prototype.getValue = function () {
        return this.input.val();
    };
    BoundWidget.prototype.getState = function () {
        return this.input.val();
    };
    BoundWidget.prototype.setState = function (state) {
        this.input.val(state);
    };
    BoundWidget.prototype.getTextLabel = function (opts) {
        var val = this.getValue();
        if (typeof val !== 'string')
            return null;
        var maxLength = opts && opts.maxLength;
        if (maxLength && val.length > maxLength) {
            return val.substring(0, maxLength - 1) + '…';
        }
        return val;
    };
    BoundWidget.prototype.focus = function () {
        this.input.focus();
    };
    return BoundWidget;
}());
var Widget = /** @class */ (function () {
    function Widget(html, idPattern) {
        this.boundWidgetClass = BoundWidget;
        this.html = html;
        this.idPattern = idPattern;
    }
    Widget.prototype.render = function (placeholder, name, id, initialState) {
        var html = this.html.replace(/__NAME__/g, name).replace(/__ID__/g, id);
        var idForLabel = this.idPattern.replace(/__ID__/g, id);
        var dom = $(html);
        $(placeholder).replaceWith(dom);
        // eslint-disable-next-line new-cap
        return new this.boundWidgetClass(dom, name, idForLabel, initialState);
    };
    return Widget;
}());
window.telepath.register('wagtail.widgets.Widget', Widget);
var BoundCheckboxInput = /** @class */ (function (_super) {
    __extends(BoundCheckboxInput, _super);
    function BoundCheckboxInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BoundCheckboxInput.prototype.getValue = function () {
        return this.input.is(':checked');
    };
    BoundCheckboxInput.prototype.getState = function () {
        return this.input.is(':checked');
    };
    BoundCheckboxInput.prototype.setState = function (state) {
        // if false, set attribute value to null to remove it
        this.input.attr('checked', state || null);
    };
    return BoundCheckboxInput;
}(BoundWidget));
var CheckboxInput = /** @class */ (function (_super) {
    __extends(CheckboxInput, _super);
    function CheckboxInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.boundWidgetClass = BoundCheckboxInput;
        return _this;
    }
    return CheckboxInput;
}(Widget));
window.telepath.register('wagtail.widgets.CheckboxInput', CheckboxInput);
var BoundRadioSelect = /** @class */ (function () {
    function BoundRadioSelect(element, name, idForLabel, initialState) {
        this.element = element;
        this.name = name;
        this.idForLabel = idForLabel;
        this.selector = 'input[name="' + name + '"]:checked';
        this.setState(initialState);
    }
    BoundRadioSelect.prototype.getValue = function () {
        return this.element.find(this.selector).val();
    };
    BoundRadioSelect.prototype.getState = function () {
        return this.element.find(this.selector).val();
    };
    BoundRadioSelect.prototype.setState = function (state) {
        this.element.find('input[name="' + this.name + '"]').val([state]);
    };
    BoundRadioSelect.prototype.focus = function () {
        this.element.find('input[name="' + this.name + '"]').focus();
    };
    return BoundRadioSelect;
}());
var RadioSelect = /** @class */ (function (_super) {
    __extends(RadioSelect, _super);
    function RadioSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.boundWidgetClass = BoundRadioSelect;
        return _this;
    }
    return RadioSelect;
}(Widget));
window.telepath.register('wagtail.widgets.RadioSelect', RadioSelect);
var BoundSelect = /** @class */ (function (_super) {
    __extends(BoundSelect, _super);
    function BoundSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BoundSelect.prototype.getTextLabel = function () {
        return this.input.find(':selected').text();
    };
    return BoundSelect;
}(BoundWidget));
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.boundWidgetClass = BoundSelect;
        return _this;
    }
    return Select;
}(Widget));
window.telepath.register('wagtail.widgets.Select', Select);
var PageChooser = /** @class */ (function () {
    function PageChooser(html, idPattern, config) {
        this.html = html;
        this.idPattern = idPattern;
        this.config = config;
    }
    PageChooser.prototype.render = function (placeholder, name, id, initialState) {
        var html = this.html.replace(/__NAME__/g, name).replace(/__ID__/g, id);
        var dom = $(html);
        $(placeholder).replaceWith(dom);
        /* the chooser object returned by createPageChooser also serves as the JS widget representation */
        // eslint-disable-next-line no-undef
        var chooser = createPageChooser(id, null, this.config);
        chooser.setState(initialState);
        return chooser;
    };
    return PageChooser;
}());
window.telepath.register('wagtail.widgets.PageChooser', PageChooser);
var AdminAutoHeightTextInput = /** @class */ (function (_super) {
    __extends(AdminAutoHeightTextInput, _super);
    function AdminAutoHeightTextInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdminAutoHeightTextInput.prototype.render = function (placeholder, name, id, initialState) {
        var boundWidget = _super.prototype.render.call(this, placeholder, name, id, initialState);
        window.autosize($('#' + id));
        return boundWidget;
    };
    return AdminAutoHeightTextInput;
}(Widget));
window.telepath.register('wagtail.widgets.AdminAutoHeightTextInput', AdminAutoHeightTextInput);
var DraftailRichTextArea = /** @class */ (function () {
    function DraftailRichTextArea(options) {
        this.options = options;
    }
    DraftailRichTextArea.prototype.render = function (container, name, id, initialState) {
        var options = this.options;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.id = id;
        input.name = name;
        input.value = initialState;
        container.appendChild(input);
        // eslint-disable-next-line no-undef
        draftail.initEditor('#' + id, options, document.currentScript);
        return {
            getValue: function () {
                return input.value;
            },
            getState: function () {
                return input.value;
            },
            setState: function () {
                throw new Error('DraftailRichTextArea.setState is not implemented');
            },
            getTextLabel: function (opts) {
                var e_1, _a;
                var maxLength = opts && opts.maxLength;
                if (!input.value)
                    return '';
                var value = JSON.parse(input.value);
                if (!value || !value.blocks)
                    return '';
                var result = '';
                try {
                    for (var _b = __values(value.blocks), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var block = _c.value;
                        if (block.text) {
                            result += (result ? ' ' + block.text : block.text);
                            if (maxLength && result.length > maxLength) {
                                return result.substring(0, maxLength - 1) + '…';
                            }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return result;
            },
            focus: function () {
                setTimeout(function () {
                    input.draftailEditor.focus();
                }, 50);
            },
        };
    };
    return DraftailRichTextArea;
}());
window.telepath.register('wagtail.widgets.DraftailRichTextArea', DraftailRichTextArea);
var BoundHalloRichTextArea = /** @class */ (function (_super) {
    __extends(BoundHalloRichTextArea, _super);
    function BoundHalloRichTextArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BoundHalloRichTextArea.prototype.setState = function (state) {
        this.input.val(state);
        this.input.siblings('[data-hallo-editor]').html(state);
    };
    BoundHalloRichTextArea.prototype.focus = function () {
        /* not implemented (leave blank so we don't try to focus the hidden field) */
    };
    return BoundHalloRichTextArea;
}(BoundWidget));
var HalloRichTextArea = /** @class */ (function (_super) {
    __extends(HalloRichTextArea, _super);
    function HalloRichTextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.boundWidgetClass = BoundHalloRichTextArea;
        return _this;
    }
    return HalloRichTextArea;
}(Widget));
window.telepath.register('wagtail.widgets.HalloRichTextArea', HalloRichTextArea);
var BaseDateTimeWidget = /** @class */ (function (_super) {
    __extends(BaseDateTimeWidget, _super);
    function BaseDateTimeWidget(options) {
        var _this = this;
        _this.options = options;
        return _this;
    }
    BaseDateTimeWidget.prototype.render = function (placeholder, name, id, initialState) {
        var element = document.createElement('input');
        element.type = 'text';
        element.name = name;
        element.id = id;
        placeholder.replaceWith(element);
        this.initChooserFn(id, this.options);
        var widget = {
            getValue: function () {
                return element.value;
            },
            getState: function () {
                return element.value;
            },
            setState: function (state) {
                element.value = state;
            },
            focus: function (opts) {
                // focusing opens the date picker, so don't do this if it's a 'soft' focus
                if (opts && opts.soft)
                    return;
                element.focus();
            },
            idForLabel: id,
        };
        widget.setState(initialState);
        return widget;
    };
    return BaseDateTimeWidget;
}(Widget));
var AdminDateInput = /** @class */ (function (_super) {
    __extends(AdminDateInput, _super);
    function AdminDateInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initChooserFn = window.initDateChooser;
        return _this;
    }
    return AdminDateInput;
}(BaseDateTimeWidget));
window.telepath.register('wagtail.widgets.AdminDateInput', AdminDateInput);
var AdminTimeInput = /** @class */ (function (_super) {
    __extends(AdminTimeInput, _super);
    function AdminTimeInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initChooserFn = window.initTimeChooser;
        return _this;
    }
    return AdminTimeInput;
}(BaseDateTimeWidget));
window.telepath.register('wagtail.widgets.AdminTimeInput', AdminTimeInput);
var AdminDateTimeInput = /** @class */ (function (_super) {
    __extends(AdminDateTimeInput, _super);
    function AdminDateTimeInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initChooserFn = window.initDateTimeChooser;
        return _this;
    }
    return AdminDateTimeInput;
}(BaseDateTimeWidget));
window.telepath.register('wagtail.widgets.AdminDateTimeInput', AdminDateTimeInput);
var ValidationError = /** @class */ (function () {
    function ValidationError(messages) {
        this.messages = messages;
    }
    return ValidationError;
}());
window.telepath.register('wagtail.errors.ValidationError', ValidationError);
